import { createSlice } from "@reduxjs/toolkit";
import { InitialOperatorCostFormData } from "../../ConstantData/InitialData";

export const operatorSlice = createSlice({
  name: "operator",
  initialState: {
    operatorList: [],
    dataEdit: {},
    isError: false,
    errorData: {},
    initialData: InitialOperatorCostFormData,
  },
  reducers: {
    getAllOperator: (state, action) => {
      state.operatorList = action.payload;
    },
    getOperator: () => {},
    getOperatorDataEdit: (state, action) => {
      state.dataEdit = action.payload;
    },
    setErrorData: (state, action) => {
      state.errorData = action.payload.message;
      state.isError = action.payload.isError;
    },
    setInitialData: (state, action) => {
      state.initialData = { ...InitialOperatorCostFormData };
    },
    createOperator: () => {},
    updateOperator: () => {},
    deleteOperator: () => {},
  },
});
export const operatorSliceAction = operatorSlice.actions;
export default operatorSlice.reducer;
